export const UPLOAD_STANDARD_TEMPLATE_REQUEST = 'UPLOAD_STANDARD_TEMPLATE_REQUEST';
export const UPLOAD_STANDARD_TEMPLATE_SUCCESS = 'UPLOAD_STANDARD_TEMPLATE_SUCCESS';
export const UPLOAD_STANDARD_TEMPLATE_FAILURE = 'UPLOAD_STANDARD_TEMPLATE_FAILURE';

export const GET_STANDARD_TEMPLATES_REQUEST = 'GET_STANDARD_TEMPLATES_REQUEST';
export const GET_STANDARD_TEMPLATES_SUCCESS = 'GET_STANDARD_TEMPLATES_SUCCESS';
export const GET_STANDARD_TEMPLATES_FAILURE = 'GET_STANDARD_TEMPLATES_FAILURE';

export const PROCESS_STANDARD_TEMPLATES_REQUEST = 'PROCESS_STANDARD_TEMPLATES_REQUEST';
export const PROCESS_STANDARD_TEMPLATES_SUCCESS = 'PROCESS_STANDARD_TEMPLATES_SUCCESS';
export const PROCESS_STANDARD_TEMPLATES_FAILURE = 'PROCESS_STANDARD_TEMPLATES_FAILURE';

export const CREATE_STANDARD_TEMPLATE_REQUEST = 'CREATE_STANDARD_TEMPLATE_REQUEST';
export const CREATE_STANDARD_TEMPLATE_SUCCESS = 'CREATE_STANDARD_TEMPLATE_SUCCESS';
export const CREATE_STANDARD_TEMPLATE_FAILURE = 'CREATE_STANDARD_TEMPLATE_FAILURE';

export const DOWNLOAD_STANDARD_TEMPLATE_REQUEST = 'DOWNLOAD_STANDARD_TEMPLATE_REQUEST';
export const DOWNLOAD_STANDARD_TEMPLATE_SUCCESS = 'DOWNLOAD_STANDARD_TEMPLATE_SUCCESS';
export const DOWNLOAD_STANDARD_TEMPLATE_FAILURE = 'DOWNLOAD_STANDARD_TEMPLATE_FAILURE';

export const DELETE_STANDARD_TEMPLATE_REQUEST = 'DELETE_STANDARD_TEMPLATE_REQUEST';
export const DELETE_STANDARD_TEMPLATE_SUCCESS = 'DELETE_STANDARD_TEMPLATE_SUCCESS';
export const DELETE_STANDARD_TEMPLATE_FAILURE = 'DELETE_STANDARD_TEMPLATE_FAILURE';

export const GET_STANDARD_TEMPLATE_JOBS_REQUEST = 'GET_STANDARD_TEMPLATE_JOBS_REQUEST';
export const GET_STANDARD_TEMPLATE_JOBS_SUCCESS = 'GET_STANDARD_TEMPLATE_JOBS_SUCCESS';
export const GET_STANDARD_TEMPLATE_JOBS_FAILURE = 'GET_STANDARD_TEMPLATE_JOBS_FAILURE';
export const RESET_STANDARD_TEMPLATE = 'RESET_STANDARD_TEMPLATE';

export const GET_STANDARD_TEMPLATE_AGGREGATES_REQUEST = 'GET_STANDARD_TEMPLATE_AGGREGATES_REQUEST';
export const GET_STANDARD_TEMPLATE_AGGREGATES_SUCCESS = 'GET_STANDARD_TEMPLATE_AGGREGATES_SUCCESS';
export const GET_STANDARD_TEMPLATE_AGGREGATES_FAILURE = 'GET_STANDARD_TEMPLATE_AGGREGATES_FAILURE';

export const GET_STANDARD_TEMPLATE_ECSL_REQUEST = 'GET_STANDARD_TEMPLATE_ECSL_REQUEST';
export const GET_STANDARD_TEMPLATE_ECSL_SUCCESS = 'GET_STANDARD_TEMPLATE_ECSL_SUCCESS';
export const GET_STANDARD_TEMPLATE_ECSL_FAILURE = 'GET_STANDARD_TEMPLATE_ECSL_FAILURE';

export const SAVE_MANUAL_ADJUSTMENTS = 'SAVE_MANUAL_ADJUSTMENTS';
export const SAVE_MANUAL_ADJUSTMENTS_SUCCESS = 'SAVE_MANUAL_ADJUSTMENTS_SUCCESS';
export const SAVE_MANUAL_ADJUSTMENTS_FAILURE = 'SAVE_MANUAL_ADJUSTMENTS_FAILURE';

export const GET_PREVIOUS_FILING_DATA_REQUEST = 'GET_PREVIOUS_FILING_DATA_REQUEST';
export const GET_PREVIOUS_FILING_DATA_SUCCESS = 'GET_PREVIOUS_FILING_DATA_SUCCESS';
export const GET_PREVIOUS_FILING_DATA_FAILURE = 'GET_PREVIOUS_FILING_DATA_FAILURE';

export const FETCH_PROCESSING_AGGREGATES_START = 'standardTemplate/fetchProcessingAggregatesStart';
export const FETCH_PROCESSING_AGGREGATES_STOP = 'standardTemplate/fetchProcessingAggregatesStop';
export const FETCH_PROCESSING_AGGREGATES_REQUEST =
  'standardTemplate/fetchProcessingAggregatesRequest';
export const FETCH_PROCESSING_AGGREGATES_SUCCESS =
  'standardTemplate/fetchProcessingAggregatesSuccess';
